import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 8 4-4 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 4v16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 8h-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 14h5l-5 6h5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUpAZ";
const ArrowUpAZ = memo(themed(Icon));
export {
  ArrowUpAZ
};
//# sourceMappingURL=arrow-up-a-z.js.map
